import BaseModalView from "scripts/views/baseModalView";
import { selectedTerms } from "scripts/views/search/facetMapper";
import { chosenAriaLabels } from "scripts/utils/chosenAriaLabels";
import templateFacetedSearchComboBoxMultiSelectModal from "templates/search/facetedSearchComboBoxMultiSelectModal.hbs";

class FacetedSearchComboBoxMultiSelectModalView extends BaseModalView {
  get events() {
    return {
      "click #bb-faceted-search-facet-modal-apply-button": "onClickApply",
    };
  }

  get className() {
    return "modal-content faceted-search-modal";
  }

  get template() {
    return templateFacetedSearchComboBoxMultiSelectModal;
  }

  render() {
    const facetLabel = this.model.get("facetLabel");
    const terms = selectedTerms(
      this.model.get("facetValues"),
      this.model.get("chosenTermCodes"),
    );

    this.$el.html(
      this.template({
        facetLabel,
        terms,
      }),
    );

    this.$el
      .find(".chosen-select")
      .chosen({
        width: "100%",
        search_contains: true,
      })
      .each(chosenAriaLabels);

    return this;
  }

  onClickApply() {
    this.trigger(
      "apply",
      this.model.get("facetParam"),
      this.$el.find(".chosen-select").val(),
    );
  }
}

export default FacetedSearchComboBoxMultiSelectModalView;
